"use strict";
exports.__esModule = true;
exports.defaultPreview = exports.unknownTagPreview = exports.liPreview = exports.trPreview = void 0;
function trPreview(el) {
    if (el.tagName !== 'TR')
        return;
    if (!el.parentNode)
        return;
    if (!el.parentNode.parentNode || el.parentNode.parentNode.tagName !== 'TABLE')
        return;
    var newTr = el.cloneNode(true);
    var tdCount = el.childElementCount;
    for (var i = 0; i < tdCount - 1; i++) {
        var computed = getComputedStyle(el.children[i]);
        newTr.children[i].style.width = computed.width;
        newTr.children[i].style.height = computed.height;
    }
    var section = el.parentNode;
    var newSection = section.cloneNode();
    newSection.appendChild(newTr);
    var table = section.parentNode;
    var newTable = table.cloneNode();
    newTable.appendChild(newSection);
    var tableComputed = getComputedStyle(table);
    newTable.style.width = tableComputed.width;
    return newTable;
}
exports.trPreview = trPreview;
function liPreview(el) {
    if (el.tagName !== 'LI')
        return;
    if (!el.parentNode)
        return;
    var tagName = el.parentNode.tagName;
    if (tagName !== 'UL' && tagName !== 'OL')
        return;
    var newLi = el.cloneNode(true);
    var computed = getComputedStyle(el);
    newLi.style.width = computed.width;
    newLi.style.height = computed.height;
    newLi.style.flex = '0 0 auto';
    var newUlOrOl = el.parentNode.cloneNode();
    newUlOrOl.appendChild(newLi);
    newUlOrOl.style.width = 'auto';
    newUlOrOl.style.height = 'auto';
    newUlOrOl.style.listStyleType = 'none';
    return newUlOrOl;
}
exports.liPreview = liPreview;
function unknownTagPreview(el) {
    var computed = getComputedStyle(el);
    var isUnknownTag = computed.display === 'inline' &&
        computed.width === 'auto' &&
        computed.height === 'auto' &&
        el.style.width === '' &&
        el.style.height === '';
    if (!isUnknownTag)
        return;
    var preview = el.cloneNode(true);
    var len = el.childElementCount;
    for (var i = 0; i < len; i++) {
        var computed_1 = getComputedStyle(el.children[i]);
        preview.children[i].style.width = computed_1.width;
        preview.children[i].style.height = computed_1.height;
    }
    return preview;
}
exports.unknownTagPreview = unknownTagPreview;
function defaultPreview(el) {
    var preview = el.cloneNode(true);
    var computed = getComputedStyle(el);
    preview.style.width = computed.width;
    preview.style.height = computed.height;
    return preview;
}
exports.defaultPreview = defaultPreview;
